import { MutationFn, UseQueryFn } from 'shared-ui';

import { PaginatedResponse } from 'core/global.types';

import { AddEventBody, Event, InneEvent, ExportEventsBody, EventsReportRequest } from './events.types';

export const fetchEvents: UseQueryFn<unknown, PaginatedResponse<Event>> = () => {
  return {
    endpoint: `/zdarzenie`,
  };
};

/**
 * WKD-2422: list of "Inne" (tryb-0) events. Separate endpoint + permission
 * (ZDARZENIA_INNE) per contract §3.2 — the normal `/zdarzenie` list excludes
 * tryb-0. Query args (offset/limit/sort/filters) are passed via `useQuery({ args })`.
 */
export const fetchInneEvents: UseQueryFn<unknown, PaginatedResponse<InneEvent>> = () => {
  return {
    endpoint: `/zdarzenie/inne`,
  };
};

export const updateEventDetails: MutationFn<{ id: string; body: Event }, void> = ({ id, body }) => {
  return {
    endpoint: `/zdarzenie/${id}`,
    method: 'PUT',
    body,
  };
};

export const addEvent: MutationFn<{ body: AddEventBody }, void> = ({ body }) => {
  return {
    endpoint: `/zdarzenie`,
    method: 'POST',
    body,
  };
};

export const exportEvents: MutationFn<{ body: ExportEventsBody }, string> = ({ body }) => {
  return {
    endpoint: `/zdarzenia/export`,
    method: 'POST',
    body,
  };
};

/**
 * WKD-2427: binary variant of /zdarzenia/export used when the operator picks a
 * system format (TYP1-4). The buffer is downloaded as a file via Blob so
 * CP1250-encoded TYP3/TYP4 content stays byte-exact (string-mode response would
 * mangle non-UTF-8 bytes).
 */
export const exportEventsBinary: MutationFn<{ body: ExportEventsBody }, ArrayBuffer> = ({ body }) => {
  return {
    endpoint: `/zdarzenia/export`,
    method: 'POST',
    body,
    responseType: 'arraybuffer',
  };
};

export const downloadEventsXlsxReport: MutationFn<{ body: EventsReportRequest }, ArrayBuffer> = ({ body }) => {
  return {
    endpoint: `/zdarzenie/report/xlsx`,
    method: 'POST',
    body,
    responseType: 'arraybuffer',
  };
};
